var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-icon",class:[_vm.sizeClass],style:(Object.assign({}, _vm.iconSize, {background: _vm.colorDefault}))},[_c('span',{staticClass:"group-name bright-color"},[_vm._v(" "+_vm._s(_vm.groupName)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }